import resemble from 'resemblejs';
import { Observable, of } from 'rxjs';
import { SmoLanguage } from '../../Models/Smo/SmoLanguage';
import { SmoMoonType } from '../../Models/Smo/SmoMoonType';
import { Optional } from '../../Utils/Types';
import { ImageWorker } from '../ImageWorker/ImageWorker';
import { ImageComparator } from './ImageComparator';

export class SmoImageComparator extends ImageWorker implements ImageComparator<SmoLanguage> {
  private cachedBaseImages: Record<string, Optional<HTMLImageElement>> = {};

  public compareImages(img1: HTMLImageElement, img2: HTMLImageElement): Observable<number> {
    const url1: string = this.createUrlFromImage(img1);
    const url2: string = this.createUrlFromImage(img2);
    return new Observable((observer) => {
      resemble(url1)
        .compareTo(url2)
        .scaleToSameSize()
        .ignoreColors()
        .onComplete((data) => {
          observer.next(parseFloat(data.misMatchPercentage));
          observer.complete();
        });
    });
  }

  public getBaseComparisonImage(moonType: SmoMoonType, language: SmoLanguage): Observable<HTMLImageElement> {
    const hashKey: string = moonType + language;
    const cachedImage: Optional<HTMLImageElement> = this.cachedBaseImages[hashKey];
    if (cachedImage) {
      return of(cachedImage);
    }

    return new Observable((observer) => {
      const baseImage: HTMLImageElement = new Image();
      baseImage.src = `/images/moon_comparison/${moonType}/${language}.png`;
      baseImage.onload = (): void => {
        this.cachedBaseImages[hashKey] = baseImage;
        observer.next(baseImage);
        observer.complete();
      };
    });
  }
}
